var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"hiq-button hiq-button--full-width hiq-button--plus hiq-events-list__loadMore",class:_vm.isVisitSite ? 'visit' : '',style:(_vm.accentBackgroundColor),on:{"click":_vm.loadMore}},[_vm._v(" Ladda fler ")])])}
var staticRenderFns = []

export { render, staticRenderFns }